import { useGetStocksQuery } from '@/features/slice/inventory';
import { useStockListApiQueryParams } from '@/modules/stocks/shared';

export const useStockList = () => {
    const queryParams = useStockListApiQueryParams();

    const { data, isLoading, isFetching, isError, error } =
        useGetStocksQuery(queryParams);

    return { data, isLoading, isFetching, isError, error };
};
